












































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import aMap from './amap.vue';
import Companys from './company.vue'
import CompanyOffWarning from './company-offwarning.vue'
import CompanyLowWarning from './company-lowwarning.vue'
class PageHomeRequest extends PageRequest {
  FilterText: string;
  status:number;
}
@Component({
  components: {aMap,Companys,CompanyOffWarning,CompanyLowWarning},
})
export default class AdminHomes extends AbpBase {
  pagerequest: PageHomeRequest = new PageHomeRequest();
  componentKey:number=0;
 //最上面的数字
  // count: number = 0;
  // offcount: number = 0;
  // oncount: number = 0;
  // lowcount: number = 0;
  // async getEquipmentCount(){
  //  let z=await this.$store.dispatch({
  //     type:"company/getEquipmentCount",
  //     data:0
  //   });
  //   if(z==1){
  //     this.componentKey++;
  //   }
  //   //console.log(list);
  // }
  // async getCount(status) {
  //   this.pagerequest.status=status;
  //   let num=await this.$store.dispatch({
  //     type: "equipment/getCount",
  //     data: this.pagerequest,
  //   });
  //   switch(status){
  //     case 0:this.count=num;break;
  //     case 1:this.oncount=num;break;
  //     case 2:this.lowcount=num;break;
  //     case 3:this.offcount=num;break;
  //   }
  // }
  // created() {
  //  this.getCount(0);
  //   this.getCount(1);
  //   this.getCount(2);
  //   this.getCount(3);
  //   this.getEquipmentCount();
  // }
   zCount = 0;
  didianliangCount = 0;
  zaixianCount = 0;
  lixianCount = 0;
 async getCount(){
    let list=await this.$store.dispatch({
      type: "thequipment/getCountHome",
    });
   this.zCount=list.zCount;
   this.didianliangCount=list.didianliangCount;
   this.zaixianCount=list.zaixianCount;
   this.lixianCount=list.lixianCount;
  }
  created() {
   this.getCount(); 
  }
}
